var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _vm.$store.getters.role == 1 ||
      _vm.$store.getters.role == 2 ||
      _vm.$store.getters.role == 4
        ? [
            _c("div", { staticClass: "container-fluid xyz" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "admin-page-content" }, [
                _c("div", { staticClass: "card" }, [
                  _c("h5", { staticClass: "card-header" }, [
                    _c("div", { staticClass: "selectdate" }, [
                      _c(
                        "div",
                        { staticClass: "selectbox1" },
                        [
                          _c("v-select", {
                            attrs: {
                              name: "location",
                              placeholder: "Type location here",
                              label: "location_name",
                              options: _vm.locationOptions
                            },
                            on: {
                              input: function($event) {
                                _vm.locationError = ""
                              }
                            },
                            model: {
                              value: _vm.selectedLocation,
                              callback: function($$v) {
                                _vm.selectedLocation = $$v
                              },
                              expression: "selectedLocation"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(_vm.locationError))
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary CustomBtnScreen",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.launchTV($event)
                            }
                          }
                        },
                        [_vm._v("Launch TV Screen")]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c("h5", { staticClass: "card-header" }, [
                    _c("div", { staticClass: "selectdate" }, [
                      _c(
                        "div",
                        { staticClass: "selectbox1" },
                        [
                          _c("label", { attrs: { for: "frontCounter" } }, [
                            _vm._v("Front Counter")
                          ]),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              name: "frontCounterLocation",
                              placeholder: "Type front counter here",
                              label: "location_name",
                              options: _vm.locationOptions
                            },
                            on: {
                              input: function($event) {
                                _vm.frontCounterLocationError = ""
                              }
                            },
                            model: {
                              value: _vm.frontCounterLocation,
                              callback: function($$v) {
                                _vm.frontCounterLocation = $$v
                              },
                              expression: "frontCounterLocation"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(_vm.frontCounterLocationError))
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "selectbox1" },
                        [
                          _c("label", { attrs: { for: "willCallLocation" } }, [
                            _vm._v("Will Call")
                          ]),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              name: "willCallLocation",
                              placeholder: "Type will call here",
                              label: "location_name",
                              options: _vm.locationOptions
                            },
                            on: {
                              input: function($event) {
                                _vm.willCallLocationError = ""
                              }
                            },
                            model: {
                              value: _vm.willCallLocation,
                              callback: function($$v) {
                                _vm.willCallLocation = $$v
                              },
                              expression: "willCallLocation"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(_vm.willCallLocationError))
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary CustomBtnScreen",
                          staticStyle: { "margin-top": "7px" },
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.launchWaitingWindow($event)
                            }
                          }
                        },
                        [_vm._v("Launch Waiting Window")]
                      )
                    ])
                  ])
                ])
              ])
            ])
          ]
        : [_c("no-permission")],
      _vm._v(" "),
      _c("app-footer")
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header-top-container" }, [
      _c("div", { staticClass: "page-name" }, [_vm._v("TV Console")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("label", { attrs: { for: "extraLabel" } })])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b8aa0a84", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8aa0a84","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TvScreen.vue
// module id = null
// module chunks = 